import { render, staticRenderFns } from "./ItemFilterGalleryLayout.vue?vue&type=template&id=6f5bbcfc&scoped=true"
import script from "./ItemFilterGalleryLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterGalleryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5bbcfc",
  null
  
)

export default component.exports